window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};





/**
 * Add class to child nav with sub-children
 * Added by JP
 */

$('ul li.desktop-nav__child:has(ul.desktop-nav__grandchildren)').addClass('has_grandchild');





/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function () {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function (array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function (array, key, value) {
    var i = array.length;
    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function (array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function (value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function () {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function (variant) {
        var satisfied = true;

        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {

      // if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
      //   return;
      // }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 63.99em)',
    medium: 'screen and (min-width: 48em) and (max-width: 63.99em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
  ==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
  ==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function (cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
    ==============================================================================*/
ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function (XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function (line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function (cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Drawer modules
  ==============================================================================*/
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function () {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function () {
  var selectors = {
    mobileNavDrawer: '#mobile-nav-drawer'
  };
  var cache = {};

  function init() {
    cacheSelectors();
    initDrawer();
  }

  function cacheSelectors() {
    cache = {
      mobileNavDrawer: $(selectors.mobileNavDrawer)
    };
  }

  function initDrawer() {
    // Add required classes to HTML
    $('.js-drawer-open-left')
      .attr('aria-controls', 'mobile-nav-drawer')
      .attr('aria-expanded', 'false');

    theme.MobileNavDrawer = new theme.Drawers('mobile-nav-drawer', 'left');
  }

  return {
    init: init
  };
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  ==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
  ==============================================================================*/
var ajaxCart = (function (module, $) {
  'use strict';
  /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
    ==============================================================================*/

  function init(options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  /*============================================================================
    PRIVATE METHODS
    ==============================================================================*/
  function _updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<p style="text-align: center; margin-top: 40px;">' + 'Ihr Einkaufswagen ist im Moment leer.' + '</p>');
      _cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function (index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        id: cartItem.id
      };

      if (cartItem.properties) {
        if (cartItem.properties._bundle == 'true') {
          var relatedProperty = '';
          jQuery.each(cartItem.properties, function (key, value) {
            relatedProperty = relatedProperty + key + value;
          })
          relatedProperty = relatedProperty.replace(/\W/g, '')
          item.related = relatedProperty

        }
      }

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };

    $cartContainer.append(template(data));

    _cartCallback(cart);
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    // Delegate all events because elements reload with the cart
    // Add or remove from the quantity


    $body.on('click', '.ajaxcart__qty-adjust', function () {
      var $btn = $(this);
      var $parent = $btn.closest(".ajaxcart__product");
      var $targetVariantId = $parent.data("variant-id");
      var $dataElement = $parent.find("[data-_bundleId]")
      var $bundleId = $dataElement.attr("data-_bundleId");
      var $inputOriginalValue = parseInt($parent.find(".ajaxcart__qty-num").val());
      // var $inputValue = parseInt($btn.next(".ajaxcart__qty-num").val()) - 1;
      var variantObj = {};
      var minusVariantObj = {};
      var plusVariantObj = {};

      $(".ajaxcart__product").each(function () {
        var $el = $(this);
        var $variantId = $el.attr("data-related")
        var $currentBundleIdElement = $el.find("[data-_bundleid]")
        var $currentBundleId = $currentBundleIdElement.attr("data-_bundleId")
        if ($currentBundleId !== undefined) {
          if ($currentBundleId === $bundleId) {
            variantObj[$variantId] = 0;
            minusVariantObj[$variantId] = parseInt(($inputOriginalValue - 1));
            plusVariantObj[$variantId] = parseInt(($inputOriginalValue + 1));
          }
        }
      })

      if (isUpdating) {
        return;
      }

      if ($btn.hasClass("ajaxcart__qty--minus")) {
        if ($bundleId !== undefined) {
          if (($inputOriginalValue - 1) == 0) {
            // console.log("dataObject", data)
            // jQuery.post('/cart/update.js', {updates: data });
            $.ajax({
              type: 'POST',
              dataType: 'json',
              data: { updates: variantObj },
              url: '/cart/update.js',
              success: function (cart) {
                _buildCart(cart)
              }
            })
            return;
          }
          else {
            $.ajax({
              type: 'POST',
              dataType: 'json',
              data: { updates: minusVariantObj },
              url: '/cart/update.js',
              success: function (cart) {
                _buildCart(cart)
              },
              error: function (err) {
                console.log(err)
              }
            })
            return;
          }
        }
      }
      else {
        if ($bundleId !== undefined) {
          $.ajax({
            type: 'POST',
            dataType: 'json',
            data: { updates: plusVariantObj },
            url: '/cart/update.js',
            success: function (cart) {
              _buildCart(cart)
            },
            error: function (err) {
              console.log(err)
            }
          })
          return;
        }
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    //remove on hitting the remove button

    $body.on('click', '.ajaxcart__product-remove', function () {

      var $btn = $(this);
      var $parent = $btn.closest(".ajaxcart__product");
      var $targetVariantId = $parent.data("variant-id");
      var $dataElement = $parent.find("[data-_bundleId]")
      var $bundleId = $dataElement.attr("data-_bundleId");
      var $inputOriginalValue = parseInt($parent.find(".ajaxcart__qty-num").val());

      var variantObj = {};

      $(".ajaxcart__product").each(function () {
        var $el = $(this);
        var $variantId = $el.attr("data-related")
        var $currentBundleIdElement = $el.find("[data-_bundleid]")
        var $currentBundleId = $currentBundleIdElement.attr("data-_bundleId")
        if ($currentBundleId !== undefined) {
          if ($currentBundleId === $bundleId) {
            variantObj[$variantId] = 0;
          }
        }
      })

      if ($bundleId !== undefined) {
        $.ajax({
          type: 'POST',
          dataType: 'json',
          data: { updates: variantObj },
          url: '/cart/update.js',
          success: function (cart) {
            _buildCart(cart)
          }
        })
        return;
      }

      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line');

      if (line) {
        updateQuantity(line, 0);
      }
    });

    // Update quantity based on input on change

    var oldInputVal;
    $body.on('keypress', '.ajaxcart__qty-num', function () {
      oldInputVal = $(this).val();
    })

    $body.on('change', '.ajaxcart__qty-num', function () {

      var $input = $(this);
      var $parent = $input.closest(".ajaxcart__product");
      var $targetVariantId = $parent.data("variant-id");
      var $dataElement = $parent.find("[data-_bundleId]")
      var $bundleId = $dataElement.attr("data-_bundleId")
      var $newInputVal = parseInt($input.val());
      // var $inputValue = parseInt($btn.next(".ajaxcart__qty-num").val()) - 1;
      var variantObj = {};
      var minusVariantObj = {};
      var plusVariantObj = {};

      $(".ajaxcart__product").each(function () {
        var $el = $(this);
        var $variantId = $el.attr("data-related")
        var $currentBundleIdElement = $el.find("[data-_bundleid]")
        var $currentBundleId = $currentBundleIdElement.attr("data-_bundleId")
        if ($currentBundleId !== undefined) {
          if ($currentBundleId === $bundleId) {
            variantObj[$variantId] = 0;
            minusVariantObj[$variantId] = parseInt(($newInputVal));
            plusVariantObj[$variantId] = parseInt(($newInputVal));
          }
        }
      })
      if ($bundleId !== undefined) {
        if ($newInputVal !== 0) {
          if (oldInputVal < $newInputVal) {
            $.ajax({
              type: 'POST',
              dataType: 'json',
              data: { updates: plusVariantObj },
              url: '/cart/update.js',
              success: function (cart) {
                _buildCart(cart)
              },
              error: function (err) {
                console.log(err)
              }
            })
            return;
          }
          else if (oldInputVal > $newInputVal) {
            $.ajax({
              type: 'POST',
              dataType: 'json',
              data: { updates: minusVariantObj },
              url: '/cart/update.js',
              success: function (cart) {
                _buildCart(cart)
              },
              error: function (err) {
                console.log(err)
              }
            })
            return;
          }
        }
        else {
          $.ajax({
            type: 'POST',
            dataType: 'json',
            data: { updates: variantObj },
            url: '/cart/update.js',
            success: function (cart) {
              _buildCart(cart)
            }
          })
          return;
        }
      }

      if (isUpdating) {
        return;
      }
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;


      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) { });
    });
  }

  function _adjustCartCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _createQtySelectors() {

    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  }

  function _qtySelectors() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = _validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        setTimeout(function () { $qtySelector.val(qty); }, 500);
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('CartDrawer', 'right', {
  onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
  formSelector: '.product-form',
  cartContainer: '#CartContainer',
  addToCartSelector: '.product-form__submit',
  cartCountSelector: '.cart-count',
  moneyFormat: theme.moneyFormat
});
// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function (evt, cart) {
  theme.CartDrawer.open();
});


/*================ Sections ================*/
theme.Tabs = (function () {

  var selectors = {
    header: '[data-js-tab-header]',
    content: '[data-js-tab-content]'
  };

  function Tabs(container) {

    var $container = $(container);
    this.$container = $(container);
    // Selectors

    this.$header = $(selectors.header, this.$container);
    this.$content = $(selectors.content, this.$container);

    this.$header.on('click', toggleTab.bind(this));

    function toggleTab(evt) {
      var $el = $(evt.currentTarget);
      var $dataId = $el.data("tab-target");
      var $tab = $("div[data-tab-id='" + $dataId + "']", $container);


      this.$header.attr("aria-selected", false)
      $el.attr("aria-selected", true)

      this.$header.attr("aria-expanded", false)
      $el.attr("aria-expanded", true)

      this.$content.attr("aria-expanded", false);
      this.$content.attr("aria-hidden", true);
      $tab.attr("aria-expanded", true)
      $tab.attr("aria-hidden", false)

      this.$header.removeClass("active");
      $el.addClass("active");
      this.$content.removeClass("active");
      $tab.addClass("active");
    }
  }

  return Tabs;
})();

// <div class="tab" data-section-type="tabs" role="tablist">
//   <div class="tab__header-container">
//     <button data-js-tab-header class="tab__header active" aria-expanded="true" data-tab-target="tab1" aria-controls="tab1" aria-selected="true">header</button>
//   </div>
//   <div class="tab__content-container">
//     <div data-js-tab-content id="tab1" aria-expanded="true" aria-hidden="false" class="tab__content active" data-tab-id="tab1">content</div>
//   </div>
// </div>
theme.Accordion = (function () {

  var selectors = {
    header: '[data-js-accordion-header]',
    content: '[data-js-accordion-content]'
  };

  function Accordion(container) {
    this.$container = $(container);

    var accordionID = '[data-accordion-parent="' + this.$container.data('accordion-id') + '"]';
    this.$header = $(accordionID + selectors.header, this.$container);
    this.$content = $(accordionID + selectors.content, this.$container);

    // This gets binded to the container so you can have more than one accordion
    this.$header.on('click', toggleAccordion.bind(this));

    function toggleAccordion(evt) {
      // $el becomes the $(this) that you click on
      var $el = $(evt.currentTarget);
      var $dataId = $el.data("accordion-target");
      var $accordion = $("[data-accordion-content='" + $dataId + "']", this.$container);

      if ($el.hasClass("active")) {
        $el.removeClass("active");
        $accordion.removeClass("active");
        this.$content.slideUp();
        $el.attr("aria-selected", false)
        $el.attr("aria-expanded", false)
        $accordion.attr("aria-expanded", false)
        $accordion.attr("aria-hidden", true)
      }
      else {
        this.$header.attr("aria-selected", false)
        $el.attr("aria-selected", true)

        this.$header.attr("aria-expanded", false)
        $el.attr("aria-expanded", true)

        this.$content.attr("aria-expanded", false);
        this.$content.attr("aria-hidden", true);
        $accordion.attr("aria-expanded", true)
        $accordion.attr("aria-hidden", false)

        this.$header.removeClass("active");
        $el.addClass("active");
        this.$content.removeClass("active");
        $accordion.addClass("active");

        // var $scrollHeight = $accordion.prop('scrollHeight')
        this.$content.slideUp();
        $accordion.slideDown();
      }
    }

    $(document).one('ready', function () {
      // var $activeScrollHeight = $(".active[data-js-accordion-content]").prop('scrollHeight');
      $(".active[data-js-accordion-content]").slideDown();
    });
  }
  return Accordion;
})();

// button and content should have matching data-accordion attributes EXCEPT data-accordion-id matches data-accordion-parent for nesting purposes

//<div data-section-type="accordion" role="accordion" data-accordion-id="accordion1">
//  <div class="accordion__content-each">
//    <button class="accordion__header" data-accordion-parent="accordion1" data-accordion-target="accordion-content1" aria-controls="accordion-content1" aria-selected="true" aria-expanded="true" data-js-accordion-header>header</button>
//    <div id="accordion-content1" class="accordion__content" data-accordion-parent="accordion1" data-accordion-content="accordion-content1" aria-expanded="true" aria-hidden="false" data-js-accordion-content>content</div>
//  </div>
//  <div class="accordion__content-each">
//    <button class="accordion__header" data-accordion-parent="accordion1" data-accordion-target="accordion-content2" aria-controls="accordion-content2" aria-selected="true" aria-expanded="true" data-js-accordion-header>header</button>
//    <div id="accordion-content1" class="accordion__content" data-accordion-parent="accordion1" data-accordion-content="accordion-content2" aria-expanded="true" aria-hidden="false" data-js-accordion-content>content</div>
//  </div>
//</div>
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
   */

theme.Product = (function () {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    saleText: '[data-sale-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    preOrder: '[data-form-pre-order]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.initSelectAnOption();
    // this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.currentPrice = parseInt($(".product-form__price").text().replace("$", "").replace(".", "").replace(",", ""))
    // this.currentPrice = this.variants.currentVariant.price;

    // Selectors
    this.$addToCart = $(selectors.addToCart, this.$container);

    // Event Handlers
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));
    this.slickProductImages();
    if ($(".select-product-customizer").length > 0) {
      this.changeSelect();
      this.filterCustomizerImages();
    }
    this.$addToCart.on('click' + this.namespace, this.checkForUpsell.bind(this));

    this.slickProductCustomizerImages();
    if (window.location.href.indexOf("&variant=") > -1) {
      this.$container.trigger({
        type: 'variantChange' + this.namespace,
        variant: this.variants.currentVariant
      });
    }
    this.productTabsAccordion();
    if ($(".select-product-customizer").length > 0) {
      this.adjustBasePrice();
      this.disableAddButton();
      this.changeSpecs();
      this.allowBuy();
    }
    if ($(".select-product-customizer").length < 1) {
      this.checkPlaceholderSelect();

    }

    // if (this.$featuredImage.length > 0) {
    //   this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
    //   slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

    //   this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    // }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function (evt) {
      var variant = evt.variant;

      if (variant) {
        console.log('va' + variant.available);
        var has_preorder = false;
        if ($('.has-preorder').length) {
          var has_preorder = true;
          console.log('ok true');
        }
        console.log(has_preorder);
        if ((variant.inventory_quantity <= 0) && (has_preorder)) {
          console.log('has pre-order');
          $(selectors.addToCartText, this.$container).html('Pre Order');
          $(selectors.preOrder, this.$container).html('<input name="properties[Status]" type="hidden" class="hidden" value="Pre order">');
        } else {
          console.log('remove pre-order');
          $(selectors.preOrder, this.$container).empty();
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        }

        $(selectors.addToCart, this.$container).prop('disabled', false).removeClass("disabled");
        $(selectors.priceWrapper, this.$container).removeClass('hide');
        console.log(variant.inventory_management);
        if (variant.inventory_management == "shopify") {
          if (variant.inventory_quantity > 0) {
            $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").removeClass("active");
          } else {
            $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").addClass("active");
          }
        } else {
          $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").removeClass("active");
        }



      } else {
        console.log('Sold out');
        $(selectors.addToCart, this.$container).prop('disabled', true).addClass("disabled");
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").removeClass("active");
        return;
      }

      if (variant.available) {
        //$(selectors.addToCart, this.$container).prop('disabled', false).removeClass("disabled");
        //$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        if (variant.inventory_management == "shopify") {
          if (variant.inventory_quantity > 0) {
            $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").removeClass("active");
          } else {
            $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").addClass("active");
          }
        } else {
          $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").removeClass("active");
        }

      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true).addClass("disabled");
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").addClass("active");
      }
    },
    slickProductCustomizerImages: function (evt) {
      $(".product-customizer-top__featured-image-slider").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        dots: true,
        nextArrow: '<button class="prod-customizer__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-1215-667H225v5017h-1440z"/><path fill="#000" fill-rule="nonzero" d="M15.626 6.054a1.38 1.38 0 0 1 0 1.89l-5.442 5.666a1.255 1.255 0 0 1-1.82 0 1.382 1.382 0 0 1 0-1.89l3.184-3.312H1.335C.597 8.408 0 7.783 0 7.01c0-.772.597-1.398 1.335-1.398h10.233L8.364 2.28a1.38 1.38 0 0 1 0-1.888 1.252 1.252 0 0 1 1.82-.002l5.442 5.663z"/></g></svg></button>',
        prevArrow: '<button class="prod-customizer__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-209-667h1440v5017H-209z"/><path fill="#000" fill-rule="nonzero" d="M.374 6.054a1.38 1.38 0 0 0 0 1.89l5.442 5.666c.503.521 1.317.519 1.82 0a1.382 1.382 0 0 0 0-1.89L4.452 8.408h10.213c.738 0 1.335-.625 1.335-1.399 0-.772-.597-1.398-1.335-1.398H4.432l3.204-3.33a1.38 1.38 0 0 0 0-1.888A1.252 1.252 0 0 0 5.816.39L.374 6.054z"/></g></svg></button>'
      });
    },
    filterCustomizerImages: function (evt) {
      var placeholder = "Select your option";
      var self = this;
      var firstSelect = false;
      $("[data-main-product]").change(function () {
        firstSelect = true
      })
      $("[data-image-change]").not("[data-main-product]").change(function () {
        firstSelect = false;
      })
      $("[data-image-change]").change(filterCustomizerImage)

      function filterCustomizerImage() {
        if (firstSelect === false) {
          var counter = 0;
          var variantName = ""
          $("[data-image-change]").each(function (i) {

            if ($(this).val() === placeholder) {
              counter += 1
            }
            else {
              var name = $(this).val()
              var handleizedName = name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              if (i == 0) {
                variantName = variantName + handleizedName
              }
              else {
                variantName = variantName + "-" + handleizedName
              }
            }
          })

          // Check if $("#selectTerrain").val() === street    counter < 3
          // If it equals to all -terrain then counter is < 3

          if ($("#selectTerrain").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "all-terrain") {
            if (counter == 2) {
              swapImages();
            }
            else {
              $(".product-form__submit").prop("disabled", true);
            }
          }
          else if ($("#selectTerrain").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "street") {
            if (counter == 3) {
              swapImages();
            }
            else {
              $(".product-form__submit").prop("disabled", true);
            }
          }
          function swapImages() {
            $(".product-customizer-top__featured-image-slider").slick("unslick");
            var $option = $("#selectImageSrc").find("option")
            var $productName;
            var $imgSrc1;
            var $imgSrc2;
            var $imgSrc3;
            var $imgSrc4;
            //             var $imgSrc5;

            $option.each(function () {

              var $this = $(this)
              $productName = $this.data("product-name");
              if ($productName == variantName) {
                $imgSrc1 = $this.data("img-src1");
                $imgSrc2 = $this.data("img-src2");
                $imgSrc3 = $this.data("img-src3");
                $imgSrc4 = $this.data("img-src4");
                //                 $imgSrc5 = $this.data("img-src5");

                $(".product-customizer__image1").attr("src", $imgSrc1);
                $(".product-customizer__image2").attr("src", $imgSrc2);
                $(".product-customizer__image3").attr("src", $imgSrc3);
                $(".product-customizer__image4").attr("src", $imgSrc4);
                //                 $(".product-customizer__image5").attr("src", $imgSrc5);
                return
              }
            })
            if ($productName === variantName) {

              var imgSrc = [];
              for (var i = 0; i < 4; i++) {

                imgSrc.push($option.attr("img-src" + i));
              }
            }

            $(".product-customizer-top__featured-image-slide").each(function (i) {
              var $img = (".product-customizer__image" + i)
            })
            self.slickProductCustomizerImages();
            // $(".product-form__submit").prop("disabled", false);  
          }
        }
      }
    },
    allowBuy: function (evt) {
      var inventoryOut = false;
      var count = 0;
      $("[data-customize-products]").change(function () {
        $("[data-customize-products]").each(function (i) {
          var $option = $(this).find("option:selected")
          if ($option.attr("data-inventory") < 1) {
            count = 1;
            console.log($option.attr("data-inventory"), "INVENTORY")
          }
        })

        if (count > 0) {
          inventoryOut = true;
        }
        else {
          inventoryOut = false;
        }
        count = 0;
      })

      $("[data-enable-btn]").change(function () {
        var mandatoryNumber = 0;
        var placeholderNumber = 0;
        $("[data-mandatory-product]").each(function () {
          if ($(this).val() !== 'Select your option') {
            mandatoryNumber += 1
          }
        })


        $("[data-enable-btn]").each(function () {
          if ($(this).val() !== 'Select your option') {
            placeholderNumber += 1
          }
        })

        if ($("#selectTerrain").val() === "Street") {
          if (placeholderNumber > 3) {
            if (inventoryOut === true) {
              $(".product-form__submit").prop("disabled", true);
            }
            else {
              if (mandatoryNumber > 3) {
                $(".product-form__submit").prop("disabled", false);
              }
              else {
                $(".product-form__submit").prop("disabled", true);
              }
            }
          }
          else {
            $(".product-form__submit").prop("disabled", true);
          }
        }
        else if ($("#selectTerrain").val() === "All Terrain") {
          if (placeholderNumber > 4) {
            if (inventoryOut === true) {
              $(".product-form__submit").prop("disabled", true);
            }
            else {
              if (mandatoryNumber > 4) {
                $(".product-form__submit").prop("disabled", false);
              }
              else {
                $(".product-form__submit").prop("disabled", true);
              }
            }
          }
          else {
            $(".product-form__submit").prop("disabled", true);
          }
        }
      })

    },
    //Force customer to Select an Option
    initSelectAnOption: function (evt) {
      if (typeof (theme.productOptions) != "undefined") {
        for (var i = 0; i < theme.productOptions.length; i++) {
          $('.product-form__variant-select-noncustomize:eq(' + i + ')', this.$container)
            .filter(function () {
              return $(this).find('option').length > 1
            })
            // .prepend('<option disabled value=""> ' + theme.productOptions[i][i] + '</option>')
            .prepend('<option disabled value=""> ' + theme.productOptions[i][i] + '</option>')
            .val('')
            .trigger('change');
          $('.product-form__variant-select-customize:eq(' + i + ')', this.$container)
            .filter(function () {
              return $(this).find('option').length > 1
            })
            // .prepend('<option disabled value=""> ' + theme.productOptions[i][i] + '</option>')
            .prepend('<option disabled value="">Select your option</option>')
            .val('')
            .trigger('change');
        }
      }
    },
    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function (evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);
      var $saleText = $(selectors.saleText, this.$container)
      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
        $saleText.html("SALE");

      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
        $saleText.html("");
      }
    },
    adjustBasePrice: function (evt) {
      var self = this;
      $("[data-main-product]").change(function () {
        $(".select-product-customizer").prop("selectedIndex", 0);
        self.currentPrice = parseInt($(".product-form__price").text().replace("$", "").replace(".", "").replace(",", ""))
      })
    },
    slickProductImages: function (evt) {
      $(".product-top__featured-image-slider").slick({
        rows: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        centerMode: true,
        centerPadding: 0,
        draggable: true,
        nextArrow: '<button class="prod__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-1215-667H225v5017h-1440z"/><path fill="#000" fill-rule="nonzero" d="M15.626 6.054a1.38 1.38 0 0 1 0 1.89l-5.442 5.666a1.255 1.255 0 0 1-1.82 0 1.382 1.382 0 0 1 0-1.89l3.184-3.312H1.335C.597 8.408 0 7.783 0 7.01c0-.772.597-1.398 1.335-1.398h10.233L8.364 2.28a1.38 1.38 0 0 1 0-1.888 1.252 1.252 0 0 1 1.82-.002l5.442 5.663z"/></g></svg></button>',
        prevArrow: '<button class="prod__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-209-667h1440v5017H-209z"/><path fill="#000" fill-rule="nonzero" d="M.374 6.054a1.38 1.38 0 0 0 0 1.89l5.442 5.666c.503.521 1.317.519 1.82 0a1.382 1.382 0 0 0 0-1.89L4.452 8.408h10.213c.738 0 1.335-.625 1.335-1.399 0-.772-.597-1.398-1.335-1.398H4.432l3.204-3.33a1.38 1.38 0 0 0 0-1.888A1.252 1.252 0 0 0 5.816.39L.374 6.054z"/></g></svg></button>',
        asNavFor: '.product-thumbnail-image__slider'
      });
      $(".product-thumbnail-image__slider").slick({
        rows: 0,
        slidesToShow: 5,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: 0,
        asNavFor: '.product-top__featured-image-slider',
        focusOnSelect: true,
        draggable: true,
        nextArrow: '<button class="prod__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-1215-667H225v5017h-1440z"/><path fill="#000" fill-rule="nonzero" d="M15.626 6.054a1.38 1.38 0 0 1 0 1.89l-5.442 5.666a1.255 1.255 0 0 1-1.82 0 1.382 1.382 0 0 1 0-1.89l3.184-3.312H1.335C.597 8.408 0 7.783 0 7.01c0-.772.597-1.398 1.335-1.398h10.233L8.364 2.28a1.38 1.38 0 0 1 0-1.888 1.252 1.252 0 0 1 1.82-.002l5.442 5.663z"/></g></svg></button>',
        prevArrow: '<button class="prod__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-209-667h1440v5017H-209z"/><path fill="#000" fill-rule="nonzero" d="M.374 6.054a1.38 1.38 0 0 0 0 1.89l5.442 5.666c.503.521 1.317.519 1.82 0a1.382 1.382 0 0 0 0-1.89L4.452 8.408h10.213c.738 0 1.335-.625 1.335-1.399 0-.772-.597-1.398-1.335-1.398H4.432l3.204-3.33a1.38 1.38 0 0 0 0-1.888A1.252 1.252 0 0 0 5.816.39L.374 6.054z"/></g></svg></button>'
      })
    },
    productTabsAccordion: function (evt) {
      enquire.register(theme.config.mediaQueries.largeUp, {
        match: function () {
          $(".tab__content .accordion__content").removeAttr("style");
        },
        unmatch: function () {
        }
      }).register(theme.config.mediaQueries.mediumDown, {
        match: function () {
          $(".active[data-js-accordion-content]").slideDown();
        },
        unmatch: function () {

        }
      })

    },
    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function (evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    checkForUpsell: function (evt) {
      if ($(".select-product-customizer").length > 0) {
        evt.preventDefault();
        var bundleId = Math.floor(Math.random() * 100000);
        var property = {
          '_bundle': true,
          '_bundleId': bundleId
        }
        var $qty = parseInt($(".js-qty__num").val());
        Shopify.queue = [];
        $("[data-customize-products]").each(function (i) {
          var $this = $(this);
          var $variantId = $this.find("option:selected").attr("data-variant-id");
          if ($variantId != undefined) {
            Shopify.queue.push({
              quantity: $qty,
              id: $variantId,
              properties: property
            })
          }
          else {
            if (typeof $this.data("main-product") !== 'undefined') {
              var $firstVal;
              var $secondVal;
              $("[data-original-product] option").each(function (i) {
                if (i === 0) {
                  $firstVal = $(this).val();
                }
                else if (i === 1) {
                  $secondVal = $(this).val();
                }

                console.log($firstVal, $secondVal, "here")
              })
              if ($("[data-main-product]").val() === "Bamboo") {
                var $currentVariant = $secondVal;
              }
              else if ($("[data-main-product]").val() === "Carbon") {
                var $currentVariant = $firstVal
              }

              Shopify.queue.push({
                quantity: $qty,
                id: $currentVariant,
                properties: property
              })
            }
          }
        })
        Shopify.queue = Shopify.queue.reverse();
        Shopify.moveAlong = function () {
          if (Shopify.queue.length) {
            var data = Shopify.queue.shift();
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              dataType: 'json',
              data: data,
              success: function (res) {
                Shopify.moveAlong();
              },
              error: function () {
                if (Shopify.queue.length) {
                  Shopify.moveAlong();
                } else {
                  ajaxCart.load();
                }
              }
            })
          } else {
            ajaxCart.load();
          }
        }
        Shopify.moveAlong()
      }
    },
    changeSelect: function (evt) {
      $(".product-info select:not([data-main-product])").prop("selectedIndex", 0);
      var placeholder = "Select your option";
      var self = this;
      // Showing certain select depending on what selected terrain is chosen
      $("#selectTerrain").change(function () {
        $(".product-form__submit").prop("disabled", true);

        // $(".select-product-customizer__change").each(function(i){
        //   if( $(this).val() !== placeholder ){
        //     var $selected = $(this).find("option:selected");
        //     var optionValue = $selected.data("variant-price");
        //     self.currentPrice = self.currentPrice - parseInt(optionValue);
        //     $(".product-form__price").html(slate.Currency.formatMoney(self.currentPrice, theme.moneyFormat))
        //   }
        // })

        if ($(this).val() === "Street") {
          $(".wheels-all-terrain, .hubs, .2in1-all-terrain").addClass("disappear");
          $(".wheels-street, .2in1-street").removeClass("disappear");
          $(".select-product-customizer__change").prop("selectedIndex", 0);
        }
        else if ($(this).val() === "All Terrain") {
          $(".wheels-all-terrain, .hubs, .2in1-all-terrain").removeClass("disappear");
          $(".wheels-street, .2in1-street").addClass("disappear");
          $(".select-product-customizer__change").prop("selectedIndex", 0);
        }
        else {
          $(".wheels-all-terrain, .hubs, .2in1-all-terrain").addClass("disappear");
          $(".wheels-street, .2in1-street").addClass("disappear");
          $(".select-product-customizer__change").prop("selectedIndex", 0);
        }
      })

      // var previous;
      // var previousPrice;
      // var previousVal;


      // if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      //   $(".select-product-customizer").mousedown( function(){
      //     previous = $(this).find("option:selected");
      //     previousVal = previous.val();
      //     previousPrice = previous.data("variant-price");
      //     if (previousPrice === undefined ){
      //       previousPrice = 0;

      //     }
      //   })
      // }
      // else{
      //   $(".select-product-customizer").on( "focus", function(){
      //     previous = $(this).find("option:selected");
      //     previousVal = previous.val();
      //     previousPrice = previous.data("variant-price");
      //     if (previousPrice === undefined ){
      //       previousPrice = 0;
      //     }
      //   })
      // }

      // $(".select-product-customizer").change(function(evt) {
      // var $el = $(evt.currentTarget);
      // var $selected = $el.find("option:selected");
      // var optionValue = $selected.data("variant-price");
      // if ($el.val() === placeholder){
      //   self.currentPrice = self.currentPrice - parseInt(previousPrice);
      //   $(".product-form__price").html(slate.Currency.formatMoney(self.currentPrice, theme.moneyFormat))

      // }
      // else{
      //   if(optionValue !== undefined){
      //     if ( previousVal !== placeholder){
      //       console.log(previousPrice, "previous Price", "self.currentPrice", self.currentPrice)
      //       self.currentPrice = parseInt(self.currentPrice) - parseInt(previousPrice);
      //       self.currentPrice = parseInt(self.currentPrice) + parseInt(optionValue);
      //     }
      //     else{
      //       self.currentPrice = self.currentPrice + parseInt(optionValue);

      //     }
      //     $(".product-form__price").html(slate.Currency.formatMoney(self.currentPrice, theme.moneyFormat))
      //   }
      // }
      // });

      $(".select-product-customizer").change(function () {
        var $originalProductPrice;
        var $carbonPrice;
        var $bambooPrice;
        var $amount = 0;
        $(".select-product-customizer").each(function () {
          var $this = $(this)
          var $option = $this.find("option:selected")
          var $price = $option.attr("data-variant-price")
          if ($price !== undefined) {
            $amount = parseInt($amount) + parseInt($price)
          }
        })

        $("[data-original-product] option").each(function (index) {
          if (index === 0) {
            $carbonPrice = $(this).attr("data-variant-price");
          }
          else if (index === 1) {
            $bambooPrice = $(this).attr("data-variant-price");
          }
        })

        if ($("[data-main-product]").val() === "Bamboo") {
          var $totalPrice = parseInt($bambooPrice) + parseInt($amount)
          $(".product-form__price").html(slate.Currency.formatMoney($totalPrice, theme.moneyFormat));
        }
        else if ($("[data-main-product]").val() === "Carbon") {
          var $totalPrice = parseInt($carbonPrice) + parseInt($amount)
          $(".product-form__price").html(slate.Currency.formatMoney($totalPrice, theme.moneyFormat))
        }

      })

    },

    disableAddButton: function (evt) {
      $(".product-form__variant-select").change(function () {
        $(".product-form__submit").prop("disabled", true);
      })
      $(".product-form__submit").prop("disabled", true);
    },
    changeSpecs: function (evt) {
      var $productHandle = $(".product-customizer").attr("data-product-handle").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');

      var $originalLengthText = $(".product-specs__title-length").first().text();
      var $originalSpeedText = $(".product-specs__title-speed").first().text();
      var $originalWeightText = $(".product-specs__title-weight").first().text();
      var $originalRangeText = $(".product-specs__title-range").first().text();

      var $lengthText = $(".product-specs__title-length");
      var $speedText = $(".product-specs__title-speed");
      var $weightText = $(".product-specs__title-weight");
      var $rangeText = $(".product-specs__title-range");

      var $terrainType;
      var placeholder = "make-a-selection";

      if ($("[data-main-product]").val() !== null) {
        var $val = $("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
      }
      if ($val == 'bamboo') {
        $lengthText.text('Length "38 inches / 970 cm"')
      }
      else if ($val == 'carbon') {
        $lengthText.text('Length "39 inches / 101 cm"')
      }
      var $specContentTab = $productHandle + "-" + $val + "-tabs";
      $(".product-customiser__specs-content").removeClass("active");
      $(".product-customiser__specs-deck").removeClass("active");
      $("." + $specContentTab + "").addClass("active");

      // Deck
      var $deckType;
      var $specContent;

      var $startingDeckType = $("[data-main-product]").val();
      if ($startingDeckType !== null) {
        if ($startingDeckType === 'Bamboo') {
          $(".bamboo-battery").addClass("active");
          $(".carbon-battery").removeClass("active");
        }
        else if ($startingDeckType === 'Carbon') {
          $(".bamboo-battery").removeClass("active");
          $(".carbon-battery").addClass("active");
        }
      }

      $("[data-main-product]").change(function () {
        $("#selectTerrain").prop("selectedIndex", 0);

        $speedText.text($originalSpeedText);
        $rangeText.text($originalRangeText);
        $weightText.text($originalWeightText);
        var $val = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        $deckType = $val;
        if ($val == 'bamboo') {
          $lengthText.text('Length "38 inches / 97cm"')
          $(".bamboo-battery").addClass("active");
          $(".carbon-battery").removeClass("active");
        }
        else if ($val == 'carbon') {
          $lengthText.text('Length "39 inches / 101cm"')
          $(".bamboo-battery").removeClass("active");
          $(".carbon-battery").addClass("active");
        }
        $specContent = $productHandle + "-" + $val + "-tabs";
        $(".product-customiser__specs-content").removeClass("active");
        $(".product-customiser__specs-deck").removeClass("active");
        $("." + $specContent + "").addClass("active");
      })
      // Terrain Type
      $("#selectTerrain").change(function () {
        $terrainType = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        $speedText.text($originalSpeedText);
        $deckType = $("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        $(".product-customiser__specs-content").removeClass("active");
        $specContent = $productHandle + "-" + $deckType + "-tabs";
        $("." + $specContent + "").addClass("active");
        if ($terrainType === placeholder) {
          $weightText.text($originalWeightText)
        }
        $(".selectBattery").each(function () {
          var $this = $(this);
          var $parent = $this.closest(".bamboo-battery")
          if ($parent.hasClass("active")) {
            if ($parent.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === placeholder) {
              $rangeText.text($originalRangeText);
            }
          }
        })
        if (($deckType == 'carbon') && ($terrainType == 'all-terrain')) {
          $weightText.text("10.7kg/23.5LBS Standard and 9.4kg/20.7LBS Travel Battery.");
        }
        else if (($deckType == 'carbon') && ($terrainType == 'street')) {
          $weightText.text("9.8kg/21.5LBS Standard and 8.4kg/18.5LBS Travel Battery.");
        }
        else if (($deckType == 'bamboo') && ($terrainType == 'all-terrain')) {
          $weightText.text("11.3kg/24.9LBS Standard and 9.5kg/20.9LBS Travel Battery.");
        }
        else if (($deckType == 'bamboo') && ($terrainType == 'street')) {
          $weightText.text("10.3kg/22LBS standard and 8.5kg/18.7LBS Travel Battery.");
        }
      })
      // Street Wheels
      $("#selectWheelsStreet").change(function () {
        var $val = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        if ($val !== placeholder) {
          $speedText.text('Top Speed "42km/h / 26mph"');
          $(".product-customiser__specs-wheels").removeClass("active");
          $(".product-customiser-street-wheels-tabs").addClass("active");
        }
        else {
          $(".product-customiser__specs-wheels").removeClass("active");
          $speedText.text($originalSpeedText);
        }
      })
      // All Terrain Wheels
      $("#selectWheelsTerrain").change(function () {
        var $val = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        if ($val !== placeholder) {
          $speedText.text('Top Speed "36km / h / 22mph"');
          $(".product-customiser__specs-wheels").removeClass("active");
          $(".product-customiser-all-terrain-wheels-tabs").addClass("active");
        }
        else {
          $(".product-customiser__specs-wheels").removeClass("active");
          $speedText.text($originalSpeedText);
        }
      })
      // Battery Type
      $(".selectBattery").change(function () {
        var $val = $(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
        if ($val !== placeholder) {
          if ($val == 'travel') {
            if ($terrainType == "all-terrain") {
              $rangeText.text("10km / 7 miles")
            }
            else if ($terrainType == 'street') {
              $rangeText.text("15km / 10 miles")
            }
            $(".product-customiser__specs-battery").removeClass("active");
            $(".product-customiser-battery-4ah-tabs").addClass("active");
          }
          else if ($val == 'standard') {
            if ($terrainType == "all-terrain") {
              $rangeText.text("30km / 19 miles")
            }
            else if ($terrainType == 'street') {
              $rangeText.text("50km / 31 miles")
            }
            $(".product-customiser__specs-battery").removeClass("active");
            $(".product-customiser-battery-14ah-tabs").addClass("active");
          }
        }
        else {
          $(".product-customiser__specs-battery").removeClass("active");
          $rangeText.text($originalRangeText);
        }
      })
      // 2 in 1
      $("#selectTerrain2in1, #selectStreet2in1").change(function () {
        if ($(this).val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === placeholder) {
          $(".selectBattery").each(function () {
            var $this = $(this);
            var $parent = $this.closest(".bamboo-battery")
            if ($parent.hasClass("active")) {
              var $batteryValue = $this.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
              if ($batteryValue == 'travel') {
                if ($terrainType == "all-terrain") {
                  $rangeText.text("10km / 7 miles")
                }
                else if ($terrainType == 'street') {
                  $rangeText.text("15km / 10 miles")
                }
                $(".product-customiser__specs-battery").removeClass("active");
                $(".product-customiser-battery-14ah-tabs").addClass("active");
              }
              else if ($batteryValue == 'standard') {
                if ($terrainType == "all-terrain") {
                  $rangeText.text("30km / 19 miles")
                }
                else if ($terrainType == 'street') {
                  $rangeText.text("30km / 31 miles")
                }
                $(".product-customiser__specs-battery").removeClass("active");
                $(".product-customiser-battery-4ah-tabs").addClass("active");
              }
            }
          })
        }
        else {
          $rangeText.text('Up to 50km / 31 miles')
        }
      })
      // Check if All Combination
      $("[data-customize-products]").change(function () {
        var number = 0;
        var $el = $(this);

        $("[data-customize-products]").each(function (i) {
          if ($(this).val() !== "Select your option") {
            number += 1
          }
        })
        if ($terrainType === "all-terrain") {
          if (number == 7) {
            $(".product-customiser-all-combination-tabs").addClass("active");
          }
          else {
            $(".product-customiser-all-combination-tabs").removeClass("active");
          }
        }
        else if ($terrainType === 'street') {
          if (number == 6) {
            $(".product-customiser-all-combination-tabs").addClass("active");
          }
          else {
            $(".product-customiser-all-combination-tabs").removeClass("active");
          }
        }
      })

      // These next to change functions to unique changes that will happen when certain product selects are selected and need to reflect in the specs tab      
      $("#selectWheelsTerrain").change(add2in1AllTerrainContent)
      function add2in1AllTerrainContent() {
        if ($("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "carbon") {
          // If carbon with all terrain wheels, no 2 in 1 
          $(".product-customiser__specs-dependant-combination").removeClass("active");
          if ($("#selectTerrain2in1").val() === "Select your option") {
            $(".product-customiser-carbon-all-terrain-no-2in1").addClass("active");
          }
          else {
            // If 2 in 1 for carbon / all terrain
            $(".product-customiser-carbon-any-wheels-any-2in1").addClass("active");
          }
        }
        else if ($("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "bamboo") {
          // If bamboo with all terrain wheels, no 2 in 1 
          $(".product-customiser__specs-dependant-combination").removeClass("active");
          if ($("#selectTerrain2in1").val() === "Select your option") {
            $(".product-customiser-bamboo-all-terrain-no-2in1").addClass("active");
          }
          else {
            // If 2 in 1 for bamboo / all terrain
            $(".product-customiser-bamboo-any-wheels-any-2in1").addClass("active");
          }
        }
      }

      $("#selectWheelsStreet").change(add2in1StreetContent)
      function add2in1StreetContent() {
        if ($("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "carbon") {
          // If carbon with Street, no 2 in 1 
          $(".product-customiser__specs-dependant-combination").removeClass("active");
          if ($("#selectStreet2in1").val() === "Select your option") {
            $(".product-customiser-carbon-street-no-2in1").addClass("active");
          }
          else {
            // If they do have 2 in 1 for carbon / all terrain
            $(".product-customiser-carbon-any-wheels-any-2in1").addClass("active");
          }
        }
        else if ($("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "bamboo") {
          // If bamboo with all street, no 2 in 1 
          $(".product-customiser__specs-dependant-combination").removeClass("active");
          if ($("#selectStreet2in1").val() === "Select your option") {
            $(".product-customiser-bamboo-street-no-2in1").addClass("active");
          }
          else {
            // If they do have 2 in 1 for bamboo / all terrain
            $(".product-customiser-bamboo-any-wheels-any-2in1").addClass("active");
          }
        }
      }
      // Checking for 2in1 on 2in1 select
      $("#selectTerrain2in1, #selectStreet2in1").change(function () {
        $(".product-customiser__specs-dependant-combination").removeClass("active");
        if ($("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "carbon") {
          if ($(this).val() !== "Select your option") {
            $(".product-customiser-carbon-any-wheels-any-2in1").addClass("active");
          }
          else {
            if ($terrainType === "all-terrain") {
              add2in1AllTerrainContent();
            }
            else if ($terrainType === "street") {
              add2in1StreetContent();
            }
          }
        }
        else if ($("[data-main-product]").val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') === "bamboo") {
          if ($(this).val() !== "Select your option") {
            $(".product-customiser-bamboo-any-wheels-any-2in1").addClass("active");
          }
          else {
            if ($terrainType === "all-terrain") {
              add2in1AllTerrainContent();
            }
            else if ($terrainType === "street") {
              add2in1StreetContent();
            }
          }
        }
      })
      $("[data-customize-products]").change(function () {
        var $hasActive = false;
        $(".product-customiser__specs-dependant-combination").each(function () {
          var $this = $(this)
          if ($this.hasClass("active")) {
            $hasActive = true;
          }
        })
        if ($hasActive) {
          $(".product-customiser__product-description").addClass("active");
        }
      })
    },
    /**
     * Event callback for Theme Editor `section:unload` event
     */
    checkPlaceholderSelect: function (evt) {
      $(".product-form__variant-select").each(function (e) {
        var $this = $(this);
        var $optionSelected = $this.find("option:selected")
        if ($optionSelected.prop("disabled")) {
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart)
          $(selectors.addToCart, this.$container).addClass("disabled");
        }
      })
      if ($("[data-add-to-cart]").text().indexOf("Sold Out") > 0) {
        $(selectors.addToCart, this.$container).addClass("disabled");
        $(".product-info__availability--out-of-stock, .product-info__availability--in-stock").addClass("active");
      }

    },
    onUnload: function () {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.ProductVideo = (function () {



  function ProductVideo(container) {

    var selectors = {
      overlay: '.product-video__overlay',
      playIcon: '.product-video__play-icon',
      video: 'video',
    };

    this.$container = $(container);
    this.$overlay = $(selectors.overlay, this.$container);
    this.$video = $(selectors.video, this.$container);
    this.$playIcon = $(selectors.playIcon, this.$container);

    this.$overlay.on('click', productVideoEffect.bind(this));

    function productVideoEffect(evt) {
      var $el = $(evt.currentTarget)
      if ($el.hasClass("active")) {
        $el.removeClass("active")
        this.$video.trigger("play");
      }
      else {
        $el.addClass("active");
        this.$video.trigger("pause");
      }
    }

  }

  return ProductVideo;
})();

theme.SiteHeader = (function () {
  function SiteHeader(container) {
    $('[name="site-select-toggle"]').on('change', function () {
      window.location = $(this).val();
    })
  }

  return SiteHeader;
})();
theme.Hero = (function () {
  function hero() {
    $('.hero__slider').slick({
      dots: true,
      arrows: false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: false
    });
  }

  return hero();
}());
theme.Collection = (function () {
  function Collection(container) {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    if (!(window.location.href.indexOf("?sort_by") > -1)) {
      $('#sort-by')
        .val('sort-by')
        .bind('change', function () {
          Shopify.queryParams.sort_by = $(this).val();
          location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
        });
    }
    else {
      var $data = $("#sort-by").data("default");

      $('#sort-by')
        .val($data)
        .bind('change', function () {
          Shopify.queryParams.sort_by = $(this).val();
          location.search = $.param(Shopify.queryParams).replace(/\+/g, '%20');
        });
    }
  }

  return Collection;
})();
theme.FeaturedPublications = (function () {
  function publications() {
    $('.js-publications__images').each(function () {
      var $carousel = $(this);

      enquire.register(theme.config.mediaQueries.largeUp, {
        match: function () {
          if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
          }

          $carousel.slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000,
          });
        },
        unmatch: function () {
        }
      }).register(theme.config.mediaQueries.medium, {
        match: function () {
          if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
          }

          $carousel.slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000
          });
        },
        unmatch: function () {
        }
      }).register(theme.config.mediaQueries.smallDown, {
        match: function () {
          if ($carousel.hasClass('slick-initialized')) {
            $carousel.slick('unslick');
          }

          $carousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            mobileFirst: true,
            dots: true,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 5000
          });
        },
        unmatch: function () {
        }
      });
    });
  }

  return publications();
});
theme.CollectionBlock = (function () {
  function CollectionBlock() {
    $('[collection-block-js]').slick({
      arrow: true,
      prevArrow: '<svg class="icon slick-prev" width="16" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.15 11.15"> <path d="M.31,4.82a1.08,1.08,0,0,0,0,1.51l4.47,4.51a1.06,1.06,0,0,0,1.49,0h0a1.09,1.09,0,0,0,0-1.5L3.66,6.7h8.39a1.12,1.12,0,0,0,0-2.23H3.64L6.27,1.82a1.08,1.08,0,0,0,0-1.51A1,1,0,0,0,4.79.3h0L.31,4.82Z" /></svg>',
      nextArrow: '<svg class="icon slick-next" width="16" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.15 11.15"><path d="M12.84,4.82a1.08,1.08,0,0,1,0,1.51L8.37,10.84a1.06,1.06,0,0,1-1.49,0h0a1.07,1.07,0,0,1,0-1.5L9.49,6.7H1.1A1.11,1.11,0,0,1,0,5.58H0A1.11,1.11,0,0,1,1.1,4.47H9.51L6.87,1.82a1.08,1.08,0,0,1,0-1.51A1.06,1.06,0,0,1,8.36.3h0l4.47,4.51Z" /> </svg>'
    });
  }
  return CollectionBlock();
})();
theme.Panels = (function () {
  function panels() {
    enquire.register(theme.config.mediaQueries.largeUp, {
      match: function () {
        if ($('.panels__container').hasClass('slick-initialized')) {
          $('.panels__container').slick('unslick');
        }
      }
    });

    enquire.register(theme.config.mediaQueries.medium, {
      match: function () {
        if ($('.panels__container').hasClass('slick-initialized')) {
          $('.panels__container').slick('unslick');
        }

        $('.panels__container').slick({
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: true,
          dots: false,
          prevArrow: '<span class="panels__slick-prev"><img class="panels__slick-prev__arrow" src="https://cdn.shopify.com/s/files/1/1357/9243/files/new-left-arrow.png?v=1589432044" /></span>',
          nextArrow: '<span class="panels__slick-next"><img class="panels__slick-next__arrow" src="https://cdn.shopify.com/s/files/1/1357/9243/files/new-right-arrow.png?v=1589432054" /></span>'
        });
      }
    });

    enquire.register(theme.config.mediaQueries.smallDown, {
      match: function () {
        if ($('.panels__container').hasClass('slick-initialized')) {
          $('.panels__container').slick('unslick');
        }

        $('.panels__container').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          centerMode: true,
          centerPadding: '35px',
          prevArrow: '<span class="panels__slick-prev"><img class="panels__slick-prev__arrow" src="https://cdn.shopify.com/s/files/1/1357/9243/files/new-left-arrow.png?v=1589432044" /></span>',
          nextArrow: '<span class="panels__slick-next"><img class="panels__slick-next__arrow" src="https://cdn.shopify.com/s/files/1/1357/9243/files/new-right-arrow.png?v=1589432054" /></span>'
        });
      }
    });
  }

  return panels();
}());
theme.Faqs = (function () {
  function faqs() {
    function internationalDistributors() {
      var distributors = [
        {
          country: "Algeria",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards.",
        },
        {
          country: "Angola",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Armenia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards.",
        },
        {
          country: "Bangladesh",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Bermuda",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Brunei",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Cambodia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Cameroon",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Cape Verde",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Central African Republic",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Chad",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "China",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Columbia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Congo",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Cook Islands",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Costa Rica",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Cyprus",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Djibouti",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Dominica",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Egypt",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "El Salvador",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Eritea",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Ethiopia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Faeroe Islands",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Fiji",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "French Guiana",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "French Polynesia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Gabon",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Ghana",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Iceland",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Indonesia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "India",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Iraq",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Ivory Coast",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Jordan",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Kenya",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Kyrgyzstan",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Laos",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Lebanon",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Lesotho",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Liberia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Libya",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Macau",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Macedonia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Madagascar",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Malawi",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Republic of Maldives",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Malta",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Marshall Islands",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Mauritius",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Mexico",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Moldova",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Mongolia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Montenegro",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Montserrat",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Morocco",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Mozambique",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Namibia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Nepal",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "New Caledonia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Nicaragua",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Niger",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Nigeria",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Northern Mariana Islands",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Oman",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Palau",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Palestine",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Papau New Guinea",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Paraguay",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Peru",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Reunion",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Rwanda",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Saba",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Saudi Arabia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Senegal",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Seychelles",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Sierra Leone",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Somalia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "South America",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Sri Lanka",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "St. Barthelme",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "St. Eustatius",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Suriname",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Swaziland",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Syria",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Tanzania",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Togo",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Tunisia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Turkey",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Uganda",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Uzbekistan",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Venezuela",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Zambia",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Zimbabwe",
          response: "We\'re sorry, but unfortunately we can\'t ship to your country due to regulations regarding the batteries we use in our boards."
        },
        {
          country: "Israel",
          response: "We\'re sorry, but unfortunately Israel customs are currently confiscating any electric skateboards sent there. For spare parts please contact <a href=\'http://www.evolveskateboards.de/index.php/en\'>Evovle Germany</a>."
        },
        {
          country: "Australia",
          response: "Please see our <a href=\'/pages/shipping-info\'>Shipping Rates and Policies"
        },
        {
          country: "Japan",
          response: "Please email: <a href=\'mailto:ask@evolveskateboards.com.au\'>ask@evovleskateboards.com.au</a> for a shipping quote."
        },
        {
          country: "United Arab Emirates",
          response: "Please email <a href=\'mailto:ask@evolveskateboards.com.au\'>ask@evovleskateboards.com.au</a> for a shipping quote."
        },
        {
          country: "Qatar",
          response: "Please email <a href=\'mailto:ask@evolveskateboards.com.au\'>ask@evovleskateboards.com.au</a> for a shipping quote."
        },
        {
          country: "Bahrain",
          response: "Please email <a href=\'mailto:ask@evolveskateboards.com.au\'>ask@evovleskateboards.com.au</a> for a shipping quote."
        },
        {
          country: "United State of America",
          response: "Your local distributor is Evolve USA<br><a href=\'https://www.evolveskateboardsusa.com/\'>https://www.evolveskateboardsusa.com/</a><br><a href=\'mailto:info@evolveskateboardsusa.com\'>info@evolveskateboardsusa.com</a><br>PH: <a href=\'tel:4423251643\'>442-325-1643</a>"
        },
        {
          country: "Canada",
          response: "Your local distributor is Evolve USA<br><a href=\'https://www.evolveskateboardsusa.com/\'>https://www.evolveskateboardsusa.com/</a><br><a href=\'mailto:info@evolveskateboardsusa.com\>info@evolveskateboardsusa.com</a><br>PH: <a href=\'tel:4423251643\'>442-325-1643</a>"
        },
        {
          country: "United Kingdom",
          response: "Your local distributor is Evolve UK<br><a href=\'https://www.evolveskateboards.co.uk/\'>https://www.evolveskateboards.co.uk/</a><br><a href=\'mailto:ask@evolveskateboards.co.uk\'>ask@evolveskateboards.co.uk</a><br>PH: <a href=\'tel:01322525059\'>01322 525059</a>"
        },
        {
          country: "Ireland",
          response: "Your local distributor is Evolve UK<br><a href=\'https://www.evolveskateboards.co.uk/\'>https://www.evolveskateboards.co.uk/</a><br><a href=\'mailto:ask@evolveskateboards.co.uk\'>ask@evolveskateboards.co.uk</a><br>PH: <a href=\'tel:01322525059\'>01322 525059</a>"
        },
        {
          country: "France",
          response: "Your local distributor is Evolve France<br><a href=\'https://evolveskateboards.fr/\'>https://evolveskateboards.fr</a><br>PH: <a href=\'tel:0178710100\'>0178710100</a>"
        },
        {
          country: "Andorra",
          response: "Your local distributor is Evolve France<br><a href=\'https://evolveskateboards.fr/\'>https://evolveskateboards.fr</a><br>PH: <a href=\'tel:0178710100\'>0178710100</a>"
        },
        {
          country: "Belgium",
          response: "Your local distributor is Evolve France<br><a href=\'https://evolveskateboards.fr/\'>https://evolveskateboards.fr</a><br>PH: <a href=\'tel:0178710100\'>0178710100</a>"
        },
        {
          country: "Luxembourg",
          response: "Your local distributor is Evolve France<br><a href=\'https://evolveskateboards.fr/\'>https://evolveskateboards.fr</a><br>PH: <a href=\'tel:0178710100\'>0178710100</a>"
        },
        {
          country: "Monaco",
          response: "Your local distributor is Evolve France<br><a href=\'https://evolveskateboards.fr/\'>https://evolveskateboards.fr</a><br>PH: <a href=\'tel:0178710100\'>0178710100</a>"
        },
        {
          country: "Germany",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Austria",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Switzerland",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Netherlands (Holland)",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Italy",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Poland",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Czech Republic (Czechia)",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Denmark",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Sweden",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Finland",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Norway",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Estonia",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Latvia",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Lithuania",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Croatia",
          response: "Your local distributor is Evolve Germany<br><a href=\'https://evolveskateboards.de/index.php/en/\'>https://evolveskateboards.de/index.php/en/</a><br><a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a><br>PH: <a href=\'tel:492114167255\'>+49 211 4167255</a>"
        },
        {
          country: "Greece",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Hungary",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Slovakia",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Romania",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Slovenia",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Ukraine",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Serbia",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "Bulgaria",
          response: "Please contact <a href=\'https://evolveskateboards.de/index.php/en/\'>Evolve Germany</a> via <a href=\'mailto:info@evolveskateboards.de\'>info@evolveskateboards.de</a> or PH: <a href=\'tel:492114167255>+49 211 4167255</a> for more info about shipping to your country."
        },
        {
          country: "South Korea",
          response: "Your local distributor is Evovle Korea<br><a href=\'http://evolveskateboards.co.kr/evolve\'>http://evolveskateboards.co.kr/evolve</a><br><a href=\'mailto:info@extm.co.kr\'>info@extm.co.kr</a><br>PH: <a href=tel:07042181520\'>070 4218 1520</a>"
        },
        {
          country: "Malaysia",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Singapore",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Hong Kong",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Thailand",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Taiwan",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Philippines",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Vietnam",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a>"
        },
        {
          country: "Indonesia",
          response: "Evolve Asia<br><a href=\'http://evolveskateboards.asia/\'>http://evolveskateboards.asia<br><a href=\'mailto:info@evolveskateboards.asia\'>info@evolveskateboards.asia</a><br>Selected Cities (they have local import laws depending on province)."
        },
        {
          country: "New Zealand",
          response: "Evolve New Zealand<br><a href=\'https://www.evovleskateboards.co.nz/\'>https://www.evolveskateboards.co.nz/</a><br><a href=\'mailto:ask@evolveskateboards.co.nz\'>ask@evovleskateboards.co.nz</a><br>PH: <a href=\'tel:092740409\'>09 274 0409</a>"
        },
        {
          country: "Russia",
          response: "Evolve Russia<br><a href=\'https://evolveskateboards.ru/\'>https://evolveskateboards.ru/</a><br><a href=\'mailto:info@evolveskateboards.ru\'>info@evovleskateboards.ru</a><br>PH: <a href=\'tel:88005001246\'>8 800 500 12 46</a>"
        },
        {
          country: "Kazakhstan",
          response: "Evolve Russia<br><a href=\'https://evolveskateboards.ru/\'>https://evolveskateboards.ru/</a><br><a href=\'mailto:info@evolveskateboards.ru\'>info@evovleskateboards.ru</a><br>PH: <a href=\'tel:88005001246\'>8 800 500 12 46</a>"
        },
        {
          country: "Belarus",
          response: "Evolve Russia<br><a href=\'https://evolveskateboards.ru/\'>https://evolveskateboards.ru/</a><br><a href=\'mailto:info@evolveskateboards.ru\'>info@evovleskateboards.ru</a><br>PH: <a href=\'tel:88005001246\'>8 800 500 12 46</a>"
        },
        {
          country: "South Africa",
          response: "Evolve South Africa<br><a href=\'mailto:hello@evolveskateboardssa.com\'>hello@evovleskateboardssa.com</a><br><a href=\'https://www.evolveskateboardssa.com/\'>https://www.evolveskateboardssa.com/</a>"
        },
        {
          country: "Spain",
          response: "Evolve Spain<br><a href=\'mailto:evolveskateboardses@gamil.com\'>evolveskateboards@gmail.com</a><br><a href=\'https://www.evolveskateboards.es/\'>https://www.evolveskateboards.es/</a><br>PH: <a href=\'tel:34649755410\'>+34 649 75 54 10</a>"
        },
        {
          country: "Portugal",
          response: "Evolve Spain<br><a href=\'mailto:evolveskateboardses@gamil.com\'>evolveskateboards@gmail.com</a><br><a href=\'https://www.evolveskateboards.es/\'>https://www.evolveskateboards.es/</a><br>PH: <a href=\'tel:34649755410\'>+34 649 75 54 10</a>"
        },
        {
          country: "Chile",
          response: "Evolve Chile<br><a href=\'https://www.evolveskateboards.cl\'>https://www.evolveskateboards.cl</a>"
        },
        {
          country: "Not Listed",
          response: "Oh no! It seems like your country isn\'t listed with one of our distributors. Please get in contact with our <a href=\'mailto:ask@evolveskateboards.com.au\'>HQ Customer Service Team</a> for further information."
        }
      ];

      // sort the distributors by country alphabetical order
      distributors.sort(function (a, b) {
        return a.country.localeCompare(b.country);
      });

      for (var i = 0; i < distributors.length; i++) {
        $('.faqs__countries').append('<option value="' + distributors[i].response + '">' + distributors[i].country + '</option>');
      }

      $('.faqs__countries').on('change', function () {
        $('.faqs__response').html($(this).val());
      });
    }

    function activeTab() {
      enquire.register(theme.config.mediaQueries.smallDown, {
        match: function () {
          $('.tab__header-container').removeClass('show');
          $('.tab__content').addClass('active');

          $('.accordion__header').each(function () {
            $(this).bind('click', function () {
              if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $(this).siblings().slideUp();
              } else {
                $(this).addClass('active');
                $(this).siblings().slideDown();
              }
            });
          });
        },
        unmatch: function () {
        }
      }).register(theme.config.mediaQueries.mediumUp, {
        match: function () {
          $('.accordion__header').unbind();
          $('.accordion__content').attr('style', 'block');

          $('.tab__header').each(function () {
            $(this).on('click', function () {
              $(this).addClass('faqs__link-active');
              $('.tab__header').not($(this)).removeClass('faqs__link-active');
              var buttonClicked = $(this).data('tab-target');
              var $parentContainer = $('#' + buttonClicked).parent();
              $parentContainer.addClass('show');
              $parentContainer.siblings().removeClass('show');
            });
          });
        },
        unmatch: function () {
        }
      });
    }

    internationalDistributors();
    activeTab();
  }

  return faqs();
});
theme.RelatedArticle = (function () {

  function RelatedArticle(container) {

    $(".related-article").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      prevArrow: '<button class="related-article__prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24"><g fill="none" fill-rule="evenodd"><path fill="#F7F7F8" d="M-69-1611h1440V845H-69z"/><path fill="#000" fill-rule="nonzero" d="M.199 11.94c.016-.254.133-.495.33-.681L11.73.622c.303-.286.756-.41 1.19-.323.434.086.782.369.914.741.132.373.026.779-.276 1.065L3.135 12l10.422 9.895c.302.286.408.692.276 1.065-.132.372-.48.655-.914.741a1.359 1.359 0 0 1-1.19-.323L.53 12.742a1.015 1.015 0 0 1-.33-.802z"/></g></svg></button>',
      nextArrow: '<button class="related-article__next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24"><g fill="none" fill-rule="evenodd"><path fill="#F7F7F8" d="M-1357-1611H83V845h-1440z"/><path fill="#000" fill-rule="nonzero" d="M13.368 11.94a1.061 1.061 0 0 0-.307-.681L2.661.622A1.2 1.2 0 0 0 1.556.3a1.133 1.133 0 0 0-.848.741c-.123.373-.025.779.256 1.065L10.642 12 .964 21.895c-.28.286-.379.692-.256 1.065.122.372.446.655.848.741a1.2 1.2 0 0 0 1.105-.323l10.4-10.636c.213-.217.324-.506.307-.802z"/></g></svg></button>'

    })
  }

  return RelatedArticle;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function () {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function () {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function () {
    $newAddressForm.toggle();
  });

  $('.address-edit-toggle').on('click', function () {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggle();
  });

  $('.address-delete').on('click', function () {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, { parameters: { _method: 'delete' } });
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function () {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggle();
    $('#CustomerLoginForm').toggle();
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').show();
  }
})();

theme.Stoke = (function () {
  var selectors = {
    infinite: '[js-infinite]',
    packery: '[js-packery]'
  };

  function Stoke(container) {
    this.$container = $(container);
    var blogHandle = this.$container.data('blog-handle')

    var infiniteScrollOptions = {
      path: '[js-infinite-trigger-' + blogHandle + ']',
      append: '.stoke-post',
      history: false,
      scrollThreshold: false,
      button: '[js-infinite-trigger-' + blogHandle + ']'
    }

    if ($(selectors.packery, this.$container).length > 0) {
      var $packery = $(selectors.packery, this.$container).packery({
        itemSelector: '.stoke-post',
        columnWidth: $('.stoke-posts').find('.stoke-post')[0],
        percentPosition: true,
        gutter: 0
      })
      var infPackery = $packery.data('packery');
      infiniteScrollOptions['outlayer'] = infPackery
    }

    $(selectors.infinite, this.$container).infiniteScroll(infiniteScrollOptions)

    this.$container.on('last.infiniteScroll', function (event, response, path) {
      $('[js-infinite-trigger]', this.$container).hide();
    });
  }

  return Stoke;
})();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('site-header', theme.SiteHeader);
  sections.register('product', theme.Product);
  sections.register('tabs', theme.Tabs);
  sections.register('accordion', theme.Accordion);
  sections.register('hero', theme.Hero);
  sections.register('featured-publications', theme.FeaturedPublications);
  sections.register('collection-block', theme.CollectionBlock);
  sections.register('product-video', theme.ProductVideo);
  sections.register('tabsAccordion', theme.Tabs);
  sections.register('tabsAccordion', theme.Accordion);
  sections.register('panels', theme.Panels);
  sections.register('collection', theme.Collection);
  sections.register('faqs', theme.Faqs);
  sections.register('stoke', theme.Stoke);
  sections.register('related-article', theme.RelatedArticle);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // init mobile drawer
  theme.MobileNav.init();
  slick_slider();
  if ($('.poup-sizeguilde').hasClass('no-value')) {
    $('.btn-size-guide').hide();
  }
  function slick_slider() {

    $('.gf_product-images-list').slick({
      dots: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: true,
      //nextArrow: '<button class="prod_arrow prod__next-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-1215-667H225v5017h-1440z"/><path fill="#000" fill-rule="nonzero" d="M15.626 6.054a1.38 1.38 0 0 1 0 1.89l-5.442 5.666a1.255 1.255 0 0 1-1.82 0 1.382 1.382 0 0 1 0-1.89l3.184-3.312H1.335C.597 8.408 0 7.783 0 7.01c0-.772.597-1.398 1.335-1.398h10.233L8.364 2.28a1.38 1.38 0 0 1 0-1.888 1.252 1.252 0 0 1 1.82-.002l5.442 5.663z"/></g></svg></button>',
      //prevArrow: '<button class="prod_arrow prod__prev-arrow" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14"><g fill="none" fill-rule="evenodd"><path d="M-209-667h1440v5017H-209z"/><path fill="#000" fill-rule="nonzero" d="M.374 6.054a1.38 1.38 0 0 0 0 1.89l5.442 5.666c.503.521 1.317.519 1.82 0a1.382 1.382 0 0 0 0-1.89L4.452 8.408h10.213c.738 0 1.335-.625 1.335-1.399 0-.772-.597-1.398-1.335-1.398H4.432l3.204-3.33a1.38 1.38 0 0 0 0-1.888A1.252 1.252 0 0 0 5.816.39L.374 6.054z"/></g></svg></button>',
      nextArrow: '<button class="prod_arrow prod__next-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 300 300"><g id="chevron-right"><polygon points="94.35,0 58.65,35.7 175.95,153 58.65,270.3 94.35,306 247.35,153"/></g></svg></button>',
      prevArrow: '<button class="prod_arrow prod__prev-arrow" type="button"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 300 300"><g><polygon points="207.093,30.187 176.907,0 48.907,128 176.907,256 207.093,225.813 109.28,128"/></g></svg></button>',
      vertical: true,
      verticalSwiping: true,
      //       centerMode: true,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },

        {
          breakpoint: 1366,
          settings: {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 1024,
          settings: {
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 4,
            slidesToScroll: 4
          }
        },
        {
          breakpoint: 992,
          settings: {
            vertical: false,
            verticalSwiping: false,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            verticalSwiping: false,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false,
          }
        },
        {
          breakpoint: 480,
          settings: {
            vertical: false,
            verticalSwiping: false,
            dots: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: false
          }
        }
      ]
    });



  }

  $(window).resize(function () {
    // slick_slider();
  });

  $(document).on('click', '.btn_checkout', function () {
    if ($(this).parents('form').find('.tos_agree').length > 0) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // $(this).parents('form').submit();
        if(typeof window.langify !== "undefined" && typeof window.langify.locale.iso_code !== "undefined" && window.langify.locale.primary === false) {
          window.location.href = "/" + window.langify.locale.iso_code + "/checkout";
        } else {
          window.location.href = "/checkout";
        }
        
      } else {
        alert("You must agree to the terms and conditions to continue checkout.");
  return false;
}
    } else {
    window.location.href = "/checkout";
  }
  });

var $notify_form = $('.notify_form .contact-form');

$(document).on('click', '.tabs li a', function (e) {
  e.preventDefault();

  var tab_id = $(this).attr('href');

  $('ul.tabs li a').removeClass('active');
  $('.tabs-content li').removeClass('active');

  $(this).addClass('active');
  $(tab_id).addClass('active');
});
  
});
